import React from 'react';
const ConfirmContext = React.createContext();
ConfirmContext.displayName = 'ConfirmContext';
export default ConfirmContext;
